// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var ref = allVue.ref;
/**
 * Represents the default `ListFilter` component.
 */

var ListFilter = {
  name: 'list-filter',
  props: {
    value: String
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var inputRef = ref(null);
    return {
      v3: v3,
      inputRef: inputRef
    };
  },
  methods: {
    onKeyDown: function onKeyDown(e) {
      this.$emit('keydown', e);
    },
    onChange: function onChange(e) {
      this.$emit('change', e);
    }
  },
  mounted: function mounted() {
    this.input = this.v3 ? this.inputRef : this.$refs.input;
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    return h("span", {
      "class": "k-list-filter"
    }, [h("input", {
      ref: this.v3 ? function (el) {
        _this.inputRef = el;
      } : 'input',
      value: this.v3 ? this.$props.value || '' : null,
      domProps: this.v3 ? undefined : {
        "value": this.$props.value || ''
      },
      "class": "k-textbox",
      onInput: this.onChange,
      on: this.v3 ? undefined : {
        "input": this.onChange,
        "keydown": this.onKeyDown
      },
      onKeydown: this.onKeyDown
    }), h("span", {
      "class": "k-icon k-i-search"
    })]);
  }
};
export { ListFilter };